import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "container",
  class: "k-scroll-color-container"
}

import { onBeforeUnmount, UnwrapRef, ref, onMounted } from 'vue';
import { ScrollingColorPicker } from './scrolling-color-picker';
import { hapticsImpactLight } from 'util/device-util';
import { useModule } from 'src/modules/modules';
import BaseScene from 'src/scenes/base';


export default /*#__PURE__*/_defineComponent({
  __name: 'scrolling-color-picker',
  props: {
    colors: null
  },
  emits: ['enter', 'select'],
  setup(__props: any, { expose, emit }) {

const { colors = [] } = __props as {
    colors: chroma.Color[]
}

const { game } = useModule();





const selected = ref(false);
const handleColorSelected = (color: chroma.Color) => {
    if (!selected.value){
        selected.value = true;
        hapticsImpactLight();
        emit('select', color);
    }
}

let scene : UnwrapRef<BaseScene> = game.gameScene!;

let scroller1 = new ScrollingColorPicker(<BaseScene> scene, [...colors], { 
    speed: Phaser.Math.Between(20, 60) / 100,
    padding: 10, 
    y: '36%' 
});

let scroller2 = new ScrollingColorPicker(<BaseScene> scene, Phaser.Utils.Array.Shuffle([...colors]), { 
    padding: 10, 
    direction: 'right', 
    stackBeneath: scroller1,
    speed: Phaser.Math.Between(20, 70) / 100
});

let scroller3 = new ScrollingColorPicker(<BaseScene> scene, 
    Phaser.Utils.Array.Shuffle([...colors]), { 
        padding: 10, 
        direction: 'left', 
        stackBeneath: scroller2,
        speed: Phaser.Math.Between(10, 50) / 100
    });

scroller1.on('select', handleColorSelected);
scroller2.on('select', handleColorSelected);
scroller3.on('select', handleColorSelected);

onMounted(async () => {
    await Promise.all([scroller1.enter(), scroller2.enter(200), scroller3.enter(400)]);
    emit('enter');
})

onBeforeUnmount(() => {
    scroller1.destroy();
    scroller2.destroy();
    scroller3.destroy();
})

expose({
    leave: () => {
        return Promise.all([scroller1.leave(), scroller2.leave(), scroller3.leave()])
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, null, 512))
}
}

})